export default __webpack_public_path__ + "static/media/jackpot.77d605fd.png";